export default __webpack_public_path__ + "static/media/plastic bag.ce8c3c58.jpg";